// Notification Types Enum
export enum NotificationType {
  CertificationExpiringSoon = 'CertificationExpiringSoon',
  CVNotUpdated = 'CVNotUpdated',
  OnBenchUpdateCV = 'OnBenchUpdateCV',
  LowCVScore = 'LowCVScore',
  PeopleAvailableSoon = 'PeopleAvailableSoon'
}

// Base notification content interface
export interface NotificationContentBase {
  personId: number;
  personEmail: string;
  personFirstName: string;
  personLastName: string;
}

// Specific notification content interfaces
export interface CVNotUpdatedNotificationContent extends NotificationContentBase {
  lastUpdateDate: string;
  daysSinceUpdate: number;
  thresholdDays: number;
}

export interface LowCVScoreNotificationContent extends NotificationContentBase {
  currentScore: number;
  thresholdScore: number;
  scoreDeficit: number;
}

export interface ExpiringCertificationContent extends NotificationContentBase {
  certificateTitle: string;
  daysUntilExpiry: number;
  expirationDate: string;
}

export interface OnBenchUpdateCVNotificationContent extends NotificationContentBase {
  lastCVUpdate?: string;
  availabilityDate?: string;
}

export interface AvailablePerson extends NotificationContentBase {
  availabilityDate?: string;
  daysUntilAvailable: number;
}

export interface PeopleAvailableSoonNotificationContent {
  people: AvailablePerson[];
  thresholdDays: number;
  peopleCount: number;
}

// Union type for all notification content types
export type NotificationContent = 
  | CVNotUpdatedNotificationContent
  | LowCVScoreNotificationContent
  | ExpiringCertificationContent
  | OnBenchUpdateCVNotificationContent
  | PeopleAvailableSoonNotificationContent;

// Generic notification interface with typed content
export interface TypedNotification<T extends NotificationContent = NotificationContent> {
  id: number;
  type: NotificationType;
  content: T;
  userId: number;
  isRead: boolean;
  createdAt: string;
  readAt?: string;
}

// Base notification interface (for backward compatibility)
export interface Notification {
  id: number;
  type: string;
  content: string;
  personId: number;
  isRead: boolean;
  createdAt: string;
  readAt?: string;
}

// Parsed notification with structured content
export interface ParsedNotification extends Omit<Notification, 'content' | 'type'> {
  type: NotificationType;
  content: NotificationContent;
  rawContent: string; // Keep original JSON string for debugging
}

export interface NotificationQuery {
  isRead?: boolean;
  take?: number;
  skip?: number;
}

export interface PersonNotificationQuery extends NotificationQuery {
  personId: number;
}

export interface NotificationsResponse {
  notifications: Notification[];
  totalCount: number;
} 